import { useEffect } from 'react';
import * as React from 'react';
import { environment } from '../environments/environment';
import { useApplicationBootHook } from '@nxplatform/spa-service/services/application-boot.hook';
import { AvailabilityStatus } from '@nxplatform/spa-service/services/base-window-setup.service';
import { BlockedPage } from '@nxplatform/spa-service/pages/blocked.page';
import BizzoModule from './modules/bizzo.module';



const pageStatusToRender = [AvailabilityStatus.ok, AvailabilityStatus.notFound];

export function App() {
  const { config } = useApplicationBootHook(environment);

  useEffect(() => {
    setTimeout(() => {
      // @ts-ignore
      import('apps/bizzo/src/styles.scss');
      // @ts-ignore
      // import('apps/bizzo/src/app/layout-select', /* webpackPreload: true */);
    }, 0);
  }, []);

  return (
    <>
      {config && (
        <>
          {pageStatusToRender.includes(config.status) && <BizzoModule />}
          {config.status === AvailabilityStatus.blocked && (
            <BlockedPage payload={config.payload} />
          )}
          {config.status === AvailabilityStatus.maintenance && (
            <BlockedPage payload={config.payload} />
          )}
        </>
      )}
    </>
  );
}

export default App;
